import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-input-date-disabled',
  templateUrl: './input-date-disabled.component.html',
  styleUrls: ['./input-date-disabled.component.scss']
})
export class InputDateDisabledComponent implements OnInit {

  @Input() label: string;
  @Input() value: string;
  @Input() style: 'bordered' | 'default' = 'default';
  @Input() theme: 'light' | 'dark' = 'light';
  @Input() isGrey = true;
  @Input() hasBorder = false;
  @Input() hasTime = false;

  constructor() { }

  ngOnInit() {
  }

}
